import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

let home = {
  state,
  mutations,
  actions,
  getters
}

export default home



// WEBPACK FOOTER //
// ./src/store/login/index.js